<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算源组</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.direction">
                <el-select style="width: 100%" v-model="direction" placeholder="请选择方向" size="mini" clearable>
                    <el-option v-for="item in directionOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.scope">
                <el-select style="width: 100%" v-model="scope" placeholder="请选择范围" size="mini" clearable>
                    <el-option v-for="item in scopeOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.is_default">
                <el-select style="width: 100%" v-model="is_default" placeholder="请选择是否为预设组" size="mini" clearable>
                    <el-option v-for="item in isDefaultOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.time_value">
                <el-date-picker
                    v-model="time_value"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="timeChange"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增预算源组</el-button>
                <el-button class="btn_success" size="small" plain :loading="btnLoading3" v-if="postList.okBtn" @click="okPass(3)"
                    >批量通过</el-button
                >
                <el-button class="btn_error" size="small" plain :loading="btnLoading4" v-if="postList.okBtn" @click="okPass(4)"
                    >批量拒绝</el-button
                >
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_item_source_group"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
                @selection-change="selectionChange"
            >
                <el-table-column type="selection" width="45" fixed="left" v-if="tab_type == '2'"></el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <!-- 上级标签处理 -->
                            <div v-if="item.prop == 'name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="提交" placement="top-start">
                            <i class="el-icon-success" @click="submit(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="审核意见" :visible.sync="dialogVisibleItem" width="30%" v-dialogDrag>
                <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="comment"> </el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button
                        @click="
                            dialogVisibleItem = false;
                            comment = '';
                        "
                        >取 消</el-button
                    >
                    <el-button type="primary" @click="subData" :loading="submitLoading">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'budgetObjectListComponent',
    data() {
        return {
            submitLoading: false,
            draggable: {
                data_name: 'budget_item_source_group'
            },
            down_loading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            time_value: '',
            direction: '', // 方向，下拉
            scope: '', // 范围，下拉
            start_time: '', // 开始版本时间结束版本时间成对出现，精确到天
            end_time: '', // 同上
            is_default: '', // 预设组，下拉，是或否
            directionOptions: [], // 方向，下拉
            scopeOptions: [], // 范围，下拉
            isDefaultOptions: [
                {
                    name: '是',
                    value: '1'
                },
                {
                    name: '否',
                    value: '2'
                }
            ],
            selected: [],
            btnLoading3: false, //批量通过
            btnLoading4: false, //批量拒绝
            tab_type: '', // tab参数1或2
            dataType: '',
            typeLabel: '',
            dialogVisibleItem: false,
            comment: '' //审核意见
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.tab_type = this.postList.params.tab_type;
        //详情内调用不用本地存储的params
        //列表页面调用 优先取本地存储
        var paramsList = JSON.parse(localStorage.getItem('paramsList'));
        if (this.tab_type == 1) {
            if (paramsList['budgetSourceList_params1']) {
                this.page = paramsList['budgetSourceList_params1'].page;
                this.row = paramsList['budgetSourceList_params1'].row;
                this.name = paramsList['budgetSourceList_params1'].name;
                // this.data_name = paramsList['budgetSourceList_params1'].data_name;
                // this.sort = paramsList['budgetSourceList_params1'].sort;
                this.is_default = paramsList['budgetSourceList_params1'].is_default;
                this.end_time = paramsList['budgetSourceList_params1'].end_time;
                this.start_time = paramsList['budgetSourceList_params1'].start_time;
                this.time_value = paramsList['budgetSourceList_params1'].time_value;
                this.scope = paramsList['budgetSourceList_params1'].scope;
                this.direction = paramsList['budgetSourceList_params1'].direction;
            }
        } else if (this.tab_type == 2) {
            if (paramsList['budgetSourceList_params2']) {
                this.page = paramsList['budgetSourceList_params2'].page;
                this.row = paramsList['budgetSourceList_params2'].row;
                this.name = paramsList['budgetSourceList_params2'].name;
                // this.data_name = paramsList['budgetSourceList_params2'].data_name;
                // this.sort = paramsList['budgetSourceList_params2'].sort;
                this.is_default = paramsList['budgetSourceList_params2'].is_default;
                this.end_time = paramsList['budgetSourceList_params2'].end_time;
                this.start_time = paramsList['budgetSourceList_params2'].start_time;
                this.time_value = paramsList['budgetSourceList_params2'].time_value;
                this.scope = paramsList['budgetSourceList_params2'].scope;
                this.direction = paramsList['budgetSourceList_params2'].direction;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getScope(); //范围下拉
            this.getDirection(); //方向下拉
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                // this.row = 10;
                this.getList(0); //获取列表
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //type == 3审批通过 type ==4 拒绝
        okPass(type) {
            this.dataType = type;
            if (this.selected.length == 0) {
                this.$message.warning('当前未选择审核数据！');
                return false;
            } else {
                this.dialogVisibleItem = true;
            }
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        },
        //提交通过拒绝弹窗
        subData() {
            if (this.dataType == 3) {
                //此处为通过
                this.submitLoading = true;
                this.btnLoading3 = true;
                let approvalList = [];
                this.selected.forEach((value) => {
                    approvalList.push(value.rid);
                });
                let postData = {
                    rids: approvalList,
                    approval_status: 3,
                    comment: this.comment
                };
                this.$api
                    .budgetItemSourceGroupBatchAudit(postData)
                    .then((res) => {
                        this.comment = '';
                        this.btnLoading3 = false;
                        this.submitLoading = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '操作成功!',
                                type: 'success'
                            });
                            this.getList(0); //获取列表
                            this.$emit('isCountShow'); //事件发射
                            this.dialogVisibleItem = false;
                        } else if (res.code == 1900) {
                            this.$message({
                                message: '批量修改成功，部分数据没有权限修改!',
                                type: 'success'
                            });
                            this.$emit('isCountShow'); //事件发射
                            this.getList(0); //获取列表
                            this.dialogVisibleItem = false;
                        }
                    })
                    .catch((error) => {
                        this.btnLoading3 = false;
                        this.submitLoading = false;
                        this.dialogVisibleItem = false;
                    });
            } else if (this.dataType == 4) {
                //此处为拒绝
                this.btnLoading4 = true;
                this.submitLoading = true;
                let approvalList = [];
                this.selected.forEach((value) => {
                    approvalList.push(value.rid);
                });
                let postData = {
                    rids: approvalList,
                    approval_status: 4,
                    comment: this.comment
                };
                this.$api
                    .budgetItemSourceGroupBatchAudit(postData)
                    .then((res) => {
                        this.comment = '';
                        this.btnLoading4 = false;
                        this.submitLoading = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '操作成功!',
                                type: 'success'
                            });
                            this.getList(0); //获取列表
                            this.dialogVisibleItem = false;
                            this.$emit('isCountShow'); //事件发射
                        } else if (res.code == 1900) {
                            this.$message({
                                message: '批量修改成功，部分数据没有权限修改!',
                                type: 'success'
                            });
                            this.getList(0); //获取列表
                            this.dialogVisibleItem = false;
                            this.$emit('isCountShow'); //事件发射
                        }
                    })
                    .catch((error) => {
                        this.btnLoading4 = false;
                        this.submitLoading = false;
                        this.dialogVisibleItem = false;
                    });
            }
        },
        //范围下拉
        getScope() {
            var params = {};
            this.$api
                .dropdownGroupScope(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.scopeOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //方向下拉
        getDirection() {
            var params = {};
            this.$api
                .dropdownGroupDirection(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.directionOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_item_source_group', this);
        },
        //版本时间框改变赋值
        timeChange(val) {
            if (val) {
                this.start_time = val[0];
                this.end_time = val[1];
            } else {
                this.start_time = '';
                this.end_time = '';
            }
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_item_source_group;
            for (let index = 0; index < this.colData.length; index++) {
                if (this.colData[index].prop == 'procedure_line_name') {
                    if (this.postList.params.tab_type == 1) {
                        this.colData[index].is_show = false;
                    } else {
                        this.colData[index].is_show = true;
                    }
                }
            }
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'budgetSourceEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(row) {
            if (row.is_default == 1) {
                this.$message.warning('预设预算源组不允许复制！');
            } else {
                this.$router.push({
                    path: '/budgetSourceEdit',
                    query: {
                        type: 5,
                        id: row.rid
                    }
                });
            }
        },
        //新增
        addAcount() {
            this.$router.push({
                path: 'budgetSourceEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'name') {
                this.$router.push({
                    path: '/budgetSourceDetail',
                    query: {
                        id: row.rid
                    }
                });
            }
        },
        submit(rid) {
            this.$confirm('您确定要提交？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['budgetItemSourceGroupSubmit']({ rid: rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条预算源组，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .budgetItemSourceGroupDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                if (newParamsList['budgetSourceList_params1']) {
                    newParamsList['budgetSourceList_params1'].data_name = val.prop;
                    newParamsList['budgetSourceList_params1'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            } else if (this.tab_type == 2) {
                if (newParamsList['budgetSourceList_params2']) {
                    newParamsList['budgetSourceList_params2'].data_name = val.prop;
                    newParamsList['budgetSourceList_params2'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                sort: [this.data_name, this.sort],
                is_export: type_data,
                direction: this.direction,
                scope: this.scope,
                start_time: this.start_time,
                time_value: this.time_value,
                end_time: this.end_time,
                is_default: this.is_default,
                tab_type: this.tab_type
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                if (this.tab_type == 1) {
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSourceList_params1'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else if (this.tab_type == 2) {
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSourceList_params2'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (type_data == 0) {
                this.$api
                    .budgetItemSourceGroupLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                if (this.tab_type == 1) {
                                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                    newParamsList['budgetSourceList_params1'].page = res.data.last_page;
                                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                    this.page = res.data.last_page;
                                } else if (this.tab_type == 2) {
                                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                    newParamsList['budgetSourceList_params2'].page = res.data.last_page;
                                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                    this.page = res.data.last_page;
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                this.$api
                    .budgetItemSourceGroupListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                if (newParamsList['budgetSourceList_params1']) {
                    newParamsList['budgetSourceList_params1'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        direction: this.direction,
                        scope: this.scope,
                        start_time: this.start_time,
                        time_value: this.time_value,
                        end_time: this.end_time,
                        is_default: this.is_default,
                        tab_type: this.tab_type
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSourceList_params1'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            } else if (this.tab_type == 2) {
                if (newParamsList['budgetSourceList_params2']) {
                    newParamsList['budgetSourceList_params2'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        direction: this.direction,
                        scope: this.scope,
                        start_time: this.start_time,
                        time_value: this.time_value,
                        end_time: this.end_time,
                        is_default: this.is_default,
                        tab_type: this.tab_type
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSourceList_params2'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }

            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                if (newParamsList['budgetSourceList_params1']) {
                    newParamsList['budgetSourceList_params1'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        direction: this.direction,
                        scope: this.scope,
                        start_time: this.start_time,
                        time_value: this.time_value,
                        end_time: this.end_time,
                        is_default: this.is_default,
                        tab_type: this.tab_type
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSourceList_params1'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            } else if (this.tab_type == 2) {
                if (newParamsList['budgetSourceList_params2']) {
                    newParamsList['budgetSourceList_params2'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        direction: this.direction,
                        scope: this.scope,
                        start_time: this.start_time,
                        time_value: this.time_value,
                        end_time: this.end_time,
                        is_default: this.is_default,
                        tab_type: this.tab_type
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSourceList_params2'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }

            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.direction = '';
            this.scope = '';
            this.time_value = '';
            this.start_time = '';
            this.time_value = '';
            this.end_time = '';
            this.is_default = '';
            this.sort = '';
            this.data_name = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                is_default: '',
                start_time: '',
                time_value: '',
                scope: '',
                direction: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                newParamsList['budgetSourceList_params1'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            } else if (this.tab_type == 2) {
                newParamsList['budgetSourceList_params2'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>